import { render, staticRenderFns } from "./trafficIndex.vue?vue&type=template&id=967f3daa&scoped=true"
import script from "./trafficIndex.vue?vue&type=script&lang=js"
export * from "./trafficIndex.vue?vue&type=script&lang=js"
import style0 from "./trafficIndex.vue?vue&type=style&index=0&id=967f3daa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967f3daa",
  null
  
)

export default component.exports